export default "__VITE_ASSET__7b33bf30__"